import React from 'react';
import { Container } from 'react-bootstrap';
import PublicNavigation from '../components/Navigation/PublicNavigation';

const sectionStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  padding: '24px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
  marginBottom: '20px',
};

const TermsOfService = () => {
  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <PublicNavigation />

      <div style={{ paddingTop: '92px', paddingBottom: '40px' }}>
        <Container style={{ maxWidth: '960px' }}>
          <div style={sectionStyle}>
            <h1 style={{ marginBottom: '8px' }}>Términos de Servicio</h1>
            <p className="text-muted mb-0">
              Los presentes Términos de Servicio regulan el acceso y uso de la plataforma Kinexion por
              parte de empresas de transporte y de sus usuarios autorizados.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>1. Servicios proporcionados</h3>
            <p>Kinexion proporciona una plataforma para que empresas de transporte puedan, entre otras actividades:</p>
            <ul>
              <li>Registrar clientes, viajes y rutas.</li>
              <li>Administrar operaciones relacionadas con empleados y unidades.</li>
              <li>Generar facturación para clientes y empleados.</li>
              <li>Emitir y administrar información relacionada con Carta Porte.</li>
              <li>Comunicarse por WhatsApp con clientes y choferes para el envío de actualizaciones relacionadas con los viajes.</li>
            </ul>
          </div>

          <div style={sectionStyle}>
            <h3>2. Responsabilidades del usuario</h3>
            <p>
              Cada empresa cliente y sus usuarios autorizados son responsables de la veracidad, integridad
              y actualización de la información que registren en la plataforma, del uso correcto de las
              herramientas de comunicación y del resguardo de sus credenciales de acceso. El cliente es
              responsable de la actividad realizada por sus usuarios dentro de su cuenta empresarial.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>3. Política de uso aceptable</h3>
            <p>
              Los usuarios no deberán utilizar la plataforma para actividades ilegales, mensajes no autorizados,
              suplantación de identidad, envío de spam, abuso de terceros, uso fraudulento de canales de
              comunicación ni para incumplir las reglas aplicables de proveedores externos como Meta o WhatsApp.
              Kinexion podrá suspender o limitar funcionalidades cuando detecte usos contrarios a esta política.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>4. Limitación de responsabilidad</h3>
            <p>
              Kinexion pone a disposición la plataforma como una herramienta operativa para empresas de transporte.
              En la medida permitida por la ley aplicable, Kinexion no será responsable por daños indirectos,
              incidentales, especiales o consecuenciales derivados del uso, interrupción, indisponibilidad o
              imposibilidad de uso del servicio, ni por fallas atribuibles a terceros, incluyendo proveedores
              de infraestructura o plataformas externas de mensajería.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>5. Terminación</h3>
            <p>
              El acceso al servicio podrá darse por terminado por solicitud del cliente, por incumplimiento de
              estos términos, por uso indebido de la plataforma o por causas operativas, legales o regulatorias
              que hagan necesario suspender total o parcialmente el servicio. La terminación no extingue las
              obligaciones pendientes que, por su naturaleza, deban subsistir.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>6. Ley aplicable</h3>
            <p>
              Estos Términos de Servicio se regirán e interpretarán conforme a las leyes aplicables de México.
              Cualquier controversia relacionada con el servicio estará sujeta al marco jurídico mexicano, salvo
              disposición legal imperativa en contrario.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default TermsOfService;
